import React, { Component } from "react";
import "./EmailSignupConsumer.css";

class EmailSignupConsumer extends Component {
  constructor() {
    super();
    this.state = {
      email: ""
    };
  }

  handleEmailInput = val => {
    this.setState({ email: val });
    console.log(this.state.email);
  };

  render() {
    const { email } = this.state;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          textAlign: "center",
          justifyContent: "flex-start"
        }}
      >
        <div style={{}}>
          <form
            action="https://docs.google.com/forms/u/1/d/e/1FAIpQLSdjnbjkFm5JnCdI0UHX_M5abSAjfWjWqBeXo40mEIT22zQzfg/formResponse"
            target="_blank"
            rel="noopener noreferrer"
            method="POST"
            id="mG61Hd"
          >
            <input type="hidden" name="fvv" value="1" />
            {/* <input
            type="hidden"
            name="draftResponse"
            value='[null,null,"-5274762868312244210"]'
          /> */}
            <input type="hidden" name="pageHistory" value="0" />
            <input type="hidden" name="fbzx" value="-5274762868312244210" />
            <div
              style={
                window.innerWidth >= 1200
                  ? { display: "flex", flexDirection: "row", width: "100%", marginTop:"10%", fontFamily:"Quicksand"}
                  : {
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      width: "100%"
                    }
              }
            >
              {/* <input
                className="email-input"
                type="email"
                jsname="YPqjbf"
                tabindex="0"
                aria-label="Email Address"
                aria-describedby="i.desc.1672297179 i.err.1672297179"
                name="entry.103811996"
                value={email}
                onChange={evt => this.handleEmailInput(evt.target.value)}
                placeholder="Email Address"
                style={
                  window.innerWidth >= 1200
                    ? {
                        backgroundColor: "transparent",
                        height: "60px",
                        width: "200px",
                        color: "#ffffff",
                        border: "none",
                        borderBottom: "1px solid #ffffff",
                        paddingLeft: "5%",
                        outline: "none",
                        marginTop:"2%"
                      }
                    : {
                        backgroundColor: "transparent",
                        height: "60px",
                        width: "200px",
                        color: "#ffffff",
                        border: "none",
                        paddingLeft: "5%",
                        outline: "none",
                        marginTop:"2%"
                      }
                }
              /> */}
              <a target="_blank" href="https://hunterhillman.typeform.com/to/tbrxGS" className="consumer-signup-button">
                <p style={{fontWeight:"600"}}>Join the waitlist</p>
              </a>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EmailSignupConsumer;
